import {analytics} from 'configs/firebase'

export const trackEvent = (event, data) => {
  try {
    if (process.env.REACT_APP_LOG_ANALYTICS_EVENTS) {
      console.log('[Analytics] track event:', {event, data})
    }

    analytics.logEvent(event, data)
  } catch (err) {
    console.warn('error logging analytics event', event, data)
  }
}

export const pageView = (url) => {
  analytics.logEvent('page_view', {page_path: url})

  if (process.env.REACT_APP_LOG_ANALYTICS_EVENTS) {
    console.log('[Analytics] page view:', url)
  }
}

export const identifyUser = (userId) => {
  analytics.setUserId(userId)

  if (process.env.REACT_APP_LOG_ANALYTICS_EVENTS) {
    console.log('[Analytics] identify:', {userId})
  }
}

export const identifyUserProperties = (userId, data) => {
  analytics.setUserProperties(data)

  if (process.env.REACT_APP_LOG_ANALYTICS_EVENTS) {
    console.log('[Analytics] identify:', {userId, data})
  }
}
